import { Injectable, signal } from '@angular/core';
import { INeighborhood, Neighborhood } from '../../models/neighborhood.model';
import { AuthService } from '../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from '../spinner/spinner.service';
import { ToastService } from '../toast/toast.service';
import { UtilService } from '../util/util.service';
import { environment } from '../../../../environments/environment';
import { IServerResponse, ServerResponse } from '../../models/server-response.model';

@Injectable({
  providedIn: 'root'
})
export class NeighborhoodService {

  public loading: boolean = false;
  public neighborhood = signal<Neighborhood | undefined>(undefined);
  /** Carga inicial del fraccionamiento; los guards la esperan antes de decidir */
  public ready: Promise<Neighborhood | undefined>;

  get currentNeighborhood(): Neighborhood | undefined {
    return this.neighborhood();
  }

  constructor(
    public authService: AuthService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService,
    private utilService: UtilService
  ) { 

    this.ready = this.get(
      environment.neighborhoodId
    );

  }

  /* -------------------------------------------------------------------------- */
  /*                            ANCHOR ensureLoaded                             */
  /* -------------------------------------------------------------------------- */
  // region ensureLoaded
  async ensureLoaded(): Promise<Neighborhood | undefined> {

    return this.neighborhood()
      ?? await this.ready
      ?? (this.ready = this.get(environment.neighborhoodId));

  }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR get                                 */
  /* -------------------------------------------------------------------------- */
  // region get
  async get(
    neighborhoodId: string
  ): Promise<Neighborhood | undefined> {

    this.loading = true;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando conjunto...';

    const urlApi = `${environment.urlApi}/neighborhoods/${neighborhoodId}`;

    try {

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await new Promise<ServerResponse<{neighborhood: INeighborhood}>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{neighborhood: INeighborhood}>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{neighborhood: INeighborhood}>
              ) => resolve(
                new ServerResponse(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {

        this.neighborhood.set(
          new Neighborhood(
            response.data!.neighborhood
          )
        );

      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch (error) {

      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );

    }

    finally {

      this.spinnerService.loading = false;
      this.spinnerService.message = '';

      this.loading = false;

    }
    
    return this.neighborhood();

  }

}
